import { useApolloClient } from '@apollo/client/react';
import { type CustomerQuery } from '../../../__generated__/graphql-client-types';
import { buildGTMCustomerLoginEvent } from '../../../helpers/analytics/gtm/event-builders';
import { CUSTOMER } from '../../../queries/customer/customer.queries';
import { type AuthenticatedCustomer } from '../../../types/authentication.types';
import { type Customer } from '../../../types/customer.types';
import { useTrackEvent } from '../../analytics/analytics.hooks';

/**
 * updates customer data post auth
 *
 * @deprecated - this hook is exported for testing purposes it should not be
 * used outside of authentication.hooks.ts
 */
export const useUpdateCustomer = () => {
	const trackEvent = useTrackEvent();
	const client = useApolloClient();

	return async (authedCustomer: AuthenticatedCustomer, isLoggedIn = true, isNewAccount = false, updatedByEmployee = false) => {
		// update jwt token
		window.__AUTHTOKEN__ = authedCustomer.token;
		// update isLoggedIn on client-side renders
		window.dataLayer.isLoggedIn = isLoggedIn;
		// clear apollo cache, refetch queries
		// In-flight errors are now throwing when they didn't before @apollo/client v4. Catching to swallow for now
		// TODO: EFDC-35512 - investigate better error handling for in-flight queries when resetting the store
		await client.resetStore().catch(() => {});

		let customer: Customer | undefined;

		// track successful logins
		if (isLoggedIn && updatedByEmployee === false) {
			const customerData = client.readQuery<CustomerQuery>({
				query: CUSTOMER
			});

			if (customerData) {
				const {
					customer: {
						id: userDBID,
						profile: { type: customerType }
					}
				} = customerData;
				trackEvent(buildGTMCustomerLoginEvent(customerType, isNewAccount, parseInt(userDBID, 10)));

				customer = customerData.customer;
			}
		}

		window.dataLayer.customer = {
			isPro: customer?.profile.type === 'PRO',
			proBusinessType: customer?.proBusinessType || '',
			userDBID: Number(customer?.id) || 0,
			email: customer?.profile.email || ''
		};
	};
};
